import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef, useEffect } from 'react';
import { HubspotFormContainer } from './HubspotForm.styles.js';

var HubspotForm = function HubspotForm(_ref) {
  var formId = _ref.formId;
  var scriptRef = useRef(null);
  useEffect(function () {
    if (typeof document === 'undefined') {
      return undefined;
    }
    var loadHubspotFormScript = function loadHubspotFormScript() {
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//js.hsforms.net/forms/embed/v2.js';
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        scriptRef.current = script;
        document.body.appendChild(script);
      });
    };
    var loadScript = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return loadHubspotFormScript();
            case 3:
              if (typeof window !== 'undefined' && window.hbspt && formId) {
                window.hbspt.forms.create({
                  region: 'na1',
                  portalId: '43602123',
                  formId: formId,
                  target: '#hubspot-form-container'
                });
              }
              _context.next = 9;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              // eslint-disable-next-line no-console
              console.error('Failed to load HubSpot form script:', _context.t0);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 6]]);
      }));
      return function loadScript() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (!scriptRef.current) {
      loadScript();
    }
    return function () {
      // Clean up script tag if component unmounts
      if (scriptRef.current && scriptRef.current.parentNode) {
        scriptRef.current.parentNode.removeChild(scriptRef.current);
        scriptRef.current = null;
      }
    };
  }, [formId]);
  return /*#__PURE__*/React__default.createElement(HubspotFormContainer, null, /*#__PURE__*/React__default.createElement("div", {
    id: "hubspot-form-container"
  }));
};
var HubspotForm$1 = HubspotForm;

export { HubspotForm$1 as default };
//# sourceMappingURL=index.js.map
